module.exports = __webpack_public_path__ + "img/storage.c3b82c30.svg";